import { openApiPcp } from '@/api/PCP/request'

export default {
  // 赠品详情
  getProductBriefInfo (requestData) {
    return openApiPcp.post('/api/product/getProductBriefInfo', requestData)
  },
  // 岸上观光通用信息
  getShorexCommonInfo (requestData) {
    return openApiPcp.post('/api/Product/ShorexCommonInfo', requestData)
  },
}
